import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center"},[_vm._t("icon",function(){return [(_vm.icon)?_c(VIcon,{staticClass:"mr-3",attrs:{"color":"be-white","size":"32"}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e()]}),_vm._t("title",function(){return [_c('h1',{staticClass:"be-white--text"},[_vm._v(_vm._s(_vm.title))])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }